import type { BusinessRole, ProfileRole, SystemRole } from "@/types/roles";

interface LandingRoles {
  systemRole?: SystemRole | string | null;
  profileRole?: ProfileRole | string | null;
  businessRole?: BusinessRole | string | null;
}

/**
 * Kushtetuta e navigimit:
 * - Superadmini shkon gjithmone te kabina globale.
 * - Pronari/admini lokal shkojne te tenant workspace.
 * - Pastaj vijne rolet profilore.
 */
export const resolveCanonicalAppPath = ({
  systemRole,
  profileRole,
  businessRole,
}: LandingRoles): string => {
  if (systemRole === "superadmin") return "/app/superadmin";
  if (businessRole === "owner") return "/app/business/manage";
  if (systemRole === "admin") return "/app/business/manage";
  if (profileRole === "technician") return "/app/laboratory/admin";
  if (profileRole === "student") return "/app/professional/profile";
  if (profileRole === "doctor" || profileRole === "specialist") return "/app/professional";
  if (profileRole === "patient") return "/app/patient";
  if (!profileRole && !businessRole) return "/app/dashboard";
  return "/app/patient";
};

export const getLandingPath = resolveCanonicalAppPath;

export const resolvePostLoginPath = (
  redirectTo: string | undefined,
  roles: LandingRoles,
): string => {
  if (
    redirectTo === "/" ||
    redirectTo === "/?create_post=1" ||
    redirectTo?.startsWith("/app") ||
    redirectTo?.startsWith("/search") ||
    redirectTo?.startsWith("/commerce") ||
    redirectTo?.startsWith("/businesses") ||
    redirectTo?.startsWith("/doctor")
  ) {
    return redirectTo;
  }
  return resolveCanonicalAppPath(roles);
};
